// Catalogus "Alle producten" (15-10-2026): filteren, sorteren en snel toevoegen.
// Toevoegen loopt via dezelfde route en hetzelfde event als sn-pdp.js, zodat de winkelwagenlade met upsell opent.
import { CartAddEvent } from '@theme/events';

const root = document.querySelector('[data-sn-plp]');

if (root) {
  let strings = {};
  try {
    strings = JSON.parse(root.querySelector('[data-sn-plp-strings]')?.textContent || '{}');
  } catch (e) {
    strings = {};
  }

  const list = root.querySelector('[data-sn-list]');
  const cards = [...root.querySelectorAll('[data-sn-card]')];
  const countEl = root.querySelector('[data-sn-count]');
  const empty = root.querySelector('[data-sn-empty]');
  const sort = root.querySelector('[data-sn-sort]');
  const filters = [...root.querySelectorAll('[data-sn-filter]')];
  const mobile = window.matchMedia('(max-width: 749px)');

  /* Bedieningselementen die alleen met JS werken pas tonen als JS draait. */
  root.querySelectorAll('[data-sn-js]').forEach((el) => {
    el.hidden = false;
  });
  if (!cards.some((card) => card.dataset.bundle === 'true')) {
    root.querySelector('[data-sn-bundles]')?.setAttribute('hidden', '');
  }

  /* Plaagstrook: pijlen, vervaging aan de randen en slepen met de muis. Vegen op touch doet de browser zelf. */
  const rail = root.querySelector('[data-sn-rail]');
  const railList = rail?.querySelector('[data-sn-rail-list]');
  if (rail && railList) {
    const prev = rail.querySelector('[data-sn-rail-prev]');
    const next = rail.querySelector('[data-sn-rail-next]');

    const updateRail = () => {
      const max = railList.scrollWidth - railList.clientWidth;
      const atStart = railList.scrollLeft <= 2;
      const atEnd = railList.scrollLeft >= max - 2;
      if (prev) prev.hidden = atStart;
      if (next) next.hidden = atEnd;
      rail.toggleAttribute('data-more-start', !atStart);
      rail.toggleAttribute('data-more-end', !atEnd);
    };
    const step = (dir) => {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      railList.scrollBy({ left: dir * railList.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
    };
    prev?.addEventListener('click', () => step(-1));
    next?.addEventListener('click', () => step(1));
    railList.addEventListener('scroll', updateRail, { passive: true });
    window.addEventListener('resize', updateRail);
    updateRail();

    let drag = null;
    railList.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = { x: event.clientX, left: railList.scrollLeft, moved: false, id: event.pointerId };
    });
    railList.addEventListener('pointermove', (event) => {
      if (!drag || event.pointerId !== drag.id) return;
      const dx = event.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) > 5) {
        drag.moved = true;
        railList.classList.add('is-dragging');
        railList.setPointerCapture(drag.id);
      }
      if (drag.moved) railList.scrollLeft = drag.left - dx;
    });
    const endDrag = () => {
      if (!drag) return;
      if (drag.moved) {
        railList.classList.remove('is-dragging');
        /* Een sleepbeweging is geen klik op de link waar hij begon. */
        const swallow = (e) => {
          e.preventDefault();
          e.stopPropagation();
        };
        railList.addEventListener('click', swallow, { capture: true, once: true });
        setTimeout(() => railList.removeEventListener('click', swallow, { capture: true }), 0);
      }
      drag = null;
    };
    railList.addEventListener('pointerup', endDrag);
    railList.addEventListener('pointercancel', endDrag);
  }

  /* Plaagfilter: de knoppen in de strook zijn links naar de plaagcollecties; met JS filteren ze dit raster.
     Het aantal per knop telt de kaarten op deze pagina. Nog een keer klikken zet het filter uit. */
  const pestLinks = [...root.querySelectorAll('[data-sn-pest]')];
  const pestMore = root.querySelector('[data-sn-pest-more]');
  const lang = (document.documentElement.lang || '').slice(0, 2);
  let activePest = null;
  const hasPest = (card, id) => (card.dataset.pests || '').includes(',' + id + ',');
  pestLinks.forEach((link) => {
    const n = cards.filter((card) => hasPest(card, link.dataset.snPest)).length;
    const li = link.closest('li');
    if (!n) {
      if (li) li.hidden = true;
      return;
    }
    const countSpan = link.querySelector('.sn-pest__count');
    if (countSpan) countSpan.textContent = String(n);
    link.setAttribute('role', 'button');
    link.setAttribute('aria-pressed', 'false');
  });
  /* Plagen zonder kaart zijn nu verborgen: pijlen van de strook opnieuw bepalen (zoekpagina met weinig treffers, 03-11). */
  window.dispatchEvent(new Event('resize'));
  /* Mobiel: knop + sheet. De lijst verhuist van de strook naar de sheet en terug. */
  const sheet = root.querySelector('[data-sn-pestsheet]');
  const sheetBody = sheet?.querySelector('[data-sn-pestsheet-body]');
  const openBtn = root.querySelector('[data-sn-pest-open]');
  const openLabel = root.querySelector('[data-sn-pest-open-label]');
  const pestsNav = root.querySelector('.sn-pests');
  const pestRail = root.querySelector('[data-sn-rail]');
  const pestList = root.querySelector('[data-sn-rail-list]');
  const defaultLabel = openLabel?.textContent || '';
  const sheetMode = () => Boolean(sheet && typeof sheet.showModal === 'function' && mobile.matches);
  const closeSheet = () => {
    if (sheet?.open) sheet.close();
  };
  const updateSheetMode = () => {
    const on = sheetMode();
    pestsNav?.classList.toggle('sn-pests--sheet', on);
    if (openBtn) openBtn.hidden = !on;
    if (!on) closeSheet();
  };
  openBtn?.addEventListener('click', () => {
    if (!sheet || !sheetBody || !pestList) return;
    sheetBody.appendChild(pestList);
    sheet.showModal();
    (pestList.querySelector('[aria-pressed="true"]') || pestList.querySelector('[data-sn-pest]'))?.focus();
  });
  sheet?.addEventListener('close', () => {
    if (pestRail && pestList && pestList.parentElement !== pestRail) pestRail.prepend(pestList);
    openBtn?.focus();
  });
  sheet?.addEventListener('click', (event) => {
    if (event.target === sheet || event.target.closest('[data-sn-pestsheet-close]')) closeSheet();
  });
  root.querySelector('[data-sn-pest-all]')?.addEventListener('click', () => {
    setPest(null);
    closeSheet();
  });
  mobile.addEventListener('change', updateSheetMode);

  const setPest = (link) => {
    activePest = link ? link.dataset.snPest : null;
    if (openLabel) openLabel.textContent = link ? link.dataset.name || defaultLabel : defaultLabel;
    openBtn?.classList.toggle('is-active', Boolean(link));
    pestLinks.forEach((l) => l.setAttribute('aria-pressed', String(l === link)));
    if (pestMore) {
      if (link) {
        /* Plaagnaam midden in de zin klein, behalve in het Duits en waar de tekst de naam na een dubbele punt zet. */
        const template = strings.pestMore || '';
        let name = link.dataset.name || '';
        if (lang !== 'de' && !template.includes(': __p__')) name = name.toLocaleLowerCase(lang || undefined);
        pestMore.textContent = template.replace('__p__', name);
        pestMore.href = link.getAttribute('href');
        pestMore.hidden = false;
      } else {
        pestMore.hidden = true;
      }
    }
    apply();
  };

  /* Filteren en sorteren op de kaarten die al in de HTML staan. */
  function apply() {
    const active = filters.filter((f) => f.checked).map((f) => f.dataset.snFilter);
    let shown = 0;
    cards.forEach((card) => {
      const visible = active.every((key) => card.dataset[key] === 'true') && (!activePest || hasPest(card, activePest));
      card.hidden = !visible;
      if (visible) shown += 1;
    });

    const mode = sort?.value || 'index';
    const num = (card, key) => Number(card.dataset[key]) || 0;
    const sorted = [...cards].sort((a, b) => {
      if (mode === 'price-asc') return num(a, 'price') - num(b, 'price') || num(a, 'index') - num(b, 'index');
      if (mode === 'price-desc') return num(b, 'price') - num(a, 'price') || num(a, 'index') - num(b, 'index');
      if (mode === 'newest') return num(b, 'created') - num(a, 'created') || num(a, 'index') - num(b, 'index');
      return num(a, 'index') - num(b, 'index');
    });
    sorted.forEach((card) => list.appendChild(card));

    if (countEl) {
      const template = shown === 1 ? countEl.dataset.one : countEl.dataset.other;
      const strong = document.createElement('strong');
      strong.textContent = (template || '').replace('__n__', String(shown));
      countEl.replaceChildren(strong);
    }
    if (empty) empty.hidden = shown > 0;
  }

  filters.forEach((f) => f.addEventListener('change', apply));
  sort?.addEventListener('change', apply);
  root.querySelector('[data-sn-reset]')?.addEventListener('click', () => {
    filters.forEach((f) => {
      f.checked = false;
    });
    setPest(null);
  });
  pestLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      /* Nieuw tabblad of venster (Ctrl, Cmd, middelste knop): gewoon de collectie openen. */
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      event.preventDefault();
      setPest(activePest === link.dataset.snPest ? null : link);
      if (sheet?.open) {
        closeSheet();
        root.querySelector('#sn-grid')?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    });
  });
  updateSheetMode();

  /* Keuzepaneel: desktop niet-modaal over de kaart, mobiel modaal als sheet onderin. */
  let openPanel = null;
  let opener = null;

  function closePanel(returnFocus = true) {
    if (!openPanel) return;
    const panel = openPanel;
    openPanel = null;
    panel.close();
    opener?.setAttribute('aria-expanded', 'false');
    if (returnFocus) opener?.focus();
  }

  root.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-sn-open]');
    if (trigger) {
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel || typeof panel.showModal !== 'function') return; // valt terug op de link naar de productpagina
      event.preventDefault();
      closePanel(false);
      opener = trigger;
      openPanel = panel;
      if (mobile.matches) panel.showModal();
      else panel.show();
      trigger.setAttribute('aria-expanded', 'true');
      (panel.querySelector('input:checked') || panel.querySelector('input:not([disabled])'))?.focus();
      return;
    }
    if (event.target.closest('[data-sn-close]')) {
      closePanel();
      return;
    }
    /* Klik op de achtergrond van de mobiele sheet. */
    if (openPanel && event.target === openPanel && mobile.matches) closePanel();
  });

  /* Desktop: klik buiten het paneel of Esc sluit het (een niet-modale dialog doet dat niet zelf). */
  document.addEventListener('click', (event) => {
    if (!openPanel || mobile.matches) return;
    if (openPanel.contains(event.target) || event.target.closest('[data-sn-open]')) return;
    closePanel(false);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && openPanel) {
      event.preventDefault();
      closePanel();
    }
  });
  /* Native Esc of sluiten van de modale sheet. */
  root.querySelectorAll('[data-sn-panel]').forEach((panel) => {
    panel.addEventListener('close', () => {
      if (openPanel === panel) {
        openPanel = null;
        opener?.setAttribute('aria-expanded', 'false');
        opener?.focus();
      }
    });
  });
  mobile.addEventListener('change', () => closePanel(false));

  /* Toevoegen aan winkelwagen. */
  async function addToCart(form) {
    const button = form.querySelector('[data-sn-buy]') || form.querySelector('[type="submit"]');
    const error = form.querySelector('[data-sn-error]');
    const label = button?.textContent;
    if (button) {
      button.setAttribute('aria-busy', 'true');
      if (button.matches('[data-sn-buy]') && strings.adding) button.textContent = strings.adding;
    }
    if (error) error.hidden = true;

    const formData = new FormData(form);
    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
      .filter(Boolean);
    if (sectionIds.length) formData.append('sections', [...new Set(sectionIds)].join(','));

    try {
      const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      });
      const data = await response.json();
      if (data.status) {
        if (error) {
          error.textContent = data.description || data.message || strings.error || '';
          error.hidden = false;
        }
        return;
      }
      if (form.closest('[data-sn-panel]')) closePanel(false);
      form.dispatchEvent(
        new CartAddEvent({}, String(formData.get('id')), {
          source: 'product-form-component',
          itemCount: Number(formData.get('quantity')) || 1,
          productId: formData.get('product-id'),
          sections: data.sections,
        })
      );
    } catch (e) {
      if (error) {
        error.textContent = strings.error || '';
        error.hidden = false;
      }
    } finally {
      if (button) {
        button.removeAttribute('aria-busy');
        if (button.matches('[data-sn-buy]') && label) button.textContent = label;
      }
    }
  }

  root.querySelectorAll('form[data-sn-plp-form]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      addToCart(form);
    });
  });
}
